import {
  CREATE_CHECKUP_FAILURE,
  CREATE_CHECKUP_SUCCESS,
  CREATE_CHECKUP,
  GET_CHECKUP_TYPE_FAILURE,
  GET_CHECKUP_TYPE_SUCCESS,
  GET_ALL_CHECKUPS_FAILURE,
  GET_ALL_CHECKUPS_SUCCESS,
  FETCH_ALL_CHECKUPS,
  FETCH_CHECKUP_TYPES,
  LOG_OUT,
} from "../constant";

const initState = {
  createCheckup: {
    success: false,
    message: "",
    error: "",
    isPost: false,
  },
  allCheckups: {
    success: false,
    allCheckups: [],
    error: "",
    isFetched: false,
    message: "",
  },
  checkupTypes: {
    success: false,
    error: "",
    checkupTypes: "",
    isFetched: false,
  },
};

export default function Checkups(state = initState, action) {
  switch (action.type) {
    case CREATE_CHECKUP:
      return {
        ...state,
        createCheckup: {
          success: false,
          message: "",
          error: "",
          isPost: false,
        },
      };
    case CREATE_CHECKUP_SUCCESS:
      return {
        ...state,
        createCheckup: {
          success: action.payload.success,
          error: "",
          message: action.payload.message,
          isPost: true,
        },
      };
    case CREATE_CHECKUP_FAILURE:
      return {
        ...state,
        createCheckup: {
          success: false,
          error: action.payload.error,
          message: "",
          isPost: true,
        },
      };

    case FETCH_ALL_CHECKUPS:
      return {
        ...state,
        allCheckups: {
          success: false,
          allCheckups: [],
          error: "",
          isFetched: false,
          message: "",
        },
      };
    case GET_ALL_CHECKUPS_SUCCESS:
      return {
        ...state,
        allCheckups: {
          success: action.payload.success,
          allCheckups: action.payload.lastCheckups,
          error: "",
          isFetched: true,
          message: action.payload.message,
        },
      };
    case GET_ALL_CHECKUPS_FAILURE:
      return {
        ...state,
        allCheckups: {
          success: false,
          error: action.payload.error,
          allCheckups: [],
          isFetched: true,
          message: "",
        },
      };

    case FETCH_CHECKUP_TYPES:
      return {
        ...state,
        checkupTypes: {
          success: false,
          error: "",
          checkupTypes: [],
          isFetched: false,
        },
      };
    case GET_CHECKUP_TYPE_SUCCESS:
      return {
        ...state,
        checkupTypes: {
          sucess: action.payload.success,
          error: "",
          checkupTypes: action.payload.checkupTypes,
          isFetched: true,
        },
      };
    case GET_CHECKUP_TYPE_FAILURE:
      return {
        ...state,
        checkupTypes: {
          error: action.payload.error,
          checkupTypes: [],
          success: false,
          isFetched: true,
        },
      };

    case LOG_OUT:
      return {
        initState,
      };
    default:
      return state;
  }
}
